import router from './index';
import store from '@/store';
import iView from 'view-design';
import { getToken, setTitle } from '@/libs/util';
import config from '@/config';

const LOGIN_PAGE_LIST = [
  '/login_supplier',
  '/login',
  '/auth/callback',
  '/aiLogin',
  '/chat',
  '/aiChat',
  '/aiMenu',
  '/scorePrinting/result',
];

const PAGE_WHILE_LIST = [
  '/login',
  '/auth/callback',
  '/home',
  '/showDoc',
  '/aiLogin',
  '/chat',
  '/aiChat',
  '/aiMenu',
  '/scorePrinting/result',
];

const titConfig = {
  '/login': 'OA管理系统',
  '/aiLogin': 'AI',
  '/chat': 'AI',
  '/aiChat': 'AI',
  '/scorePrinting/result': '学生成绩打印',
};
iView.LoadingBar.config({
  height: Math.ceil(document.body.clientHeight / 200),
});

router.beforeEach(async (to, from, next) => {
  iView.LoadingBar.start();
  // 当跳到登录页 切换标题
  if (Object.keys(titConfig).includes(to.path)) {
    config.title = titConfig[to.path];
  }
  // 登录后根据角色更新主标题
  if (LOGIN_PAGE_LIST.includes(from.path)) {
    if (store.state.user.userCode.indexOf('admin') > -1) {
      config.title = titConfig['/login'];
    } else {
      config.title = titConfig['/login_supplier'];
    }
  }
  const token = getToken();
  if (token) {
    // 根据身份跳转路由
    if (store.state.permission.routes.length > 0) {
      next();
    } else {
      try {
        // 获取用户权限信息
        const userAccess = store.state.app.access;
        const userAccessStr = userAccess ? JSON.parse(userAccess) : [];
        const userAccessArrStr = userAccessStr.replace(/'|\[|\]|"/g, '');
        const userAccessArr = userAccessArrStr.split(',');
        // 获取当前用户需要添加的路由
        const asyncRoutes = await store.dispatch(
          'permission/generateRoutes',
          userAccessArr,
        );

        router.options.routes = store.state.permission.routes;
        // 动态添加路由
        router.addRoutes(asyncRoutes);
        // hack方法来确保地址是完整的
        // 设置replace: true, 导航将不会留下历史记录
        next({ ...to, replace: true });
      } catch (error) {
        await store.dispatch('handleLogOut');
        if (LOGIN_PAGE_LIST.includes(to.path)) {
          next();
        } else {
          next({
            path: '/login', // 跳转到登录页
          });
        }
      }
    }
  } else {
    // 只要在路由白名单内直接跳转
    console.log(to.path, '白名单');
    if (PAGE_WHILE_LIST.includes(to.path)) {
      next();
    } else {
      // 没有 token 时跳转到登录页
      localStorage.clear();
      sessionStorage.clear();
      next({
        path: '/login',
        query: { redirect: to.fullPath },
      });
    }
  }
});

router.afterEach((to) => {
  setTitle(to, router.app);
  iView.LoadingBar.finish();
  window.scrollTo(0, 0);
});
